import { render, staticRenderFns } from "./RegistrationModal.vue?vue&type=template&id=f0a26bd6&scoped=true&"
import script from "./RegistrationModal.vue?vue&type=script&lang=js&"
export * from "./RegistrationModal.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationModal.vue?vue&type=style&index=0&id=f0a26bd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a26bd6",
  null
  
)

export default component.exports